<!--
  https://trello.com/c/njNcSpxI/169-pita-pit-bugs-07012019 item 9
-->

<template>
  <div
    slot="modal-body"
    class="modal-body"
  >
    <div v-if="$root.activeLocation.id === undefined">
      <div class="row">
        <div class="col-md-12">
          <div
            v-if="!$root.activeLocation.id"
            class="alert alert-info center margin-top-20"
          >
            <h4>No Store Selected</h4>
            <p>Please select a store from the stores panel on the right to view Modifiers</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
    >
      <div class="portlet-body">
        <div class="row">
          <div class="col-md-12">
            <div
              v-show="errorMessage"
              ref="errorMessage"
              class="alert alert-danger"
            >
              <button
                class="close"
                @click="clearError('errorMessage')"
              />
              <span>{{ errorMessage }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h4>Modifier Categories</h4>
            <div v-if="loadingModifiers && !modifiers.length">
              <div class="alert alert-info">
                <span>Loading...</span>
              </div>
            </div>
            <div
              v-else-if="modifiers.length && !loadingModifiers"
              id="nestable_list_1"
              class="dd"
            >
              <ol class="dd-list">
                <li
                  v-for="modifier in modifiers"
                  :key="modifier.id"
                  class="dd-item"
                  :data-id="modifier.id"
                  @click="selectModifier(modifier)"
                >
                  <div
                    class="dd-handle"
                    :class="{'active': modifier.id === activeModifier.id}"
                  >
                    {{ modifier.name }}
                    <span class="pull-right">
                      <i class="fa fa-chevron-right" />
                    </span>
                  </div>
                </li>
              </ol>
            </div>
            <div v-else>
              <div class="alert alert-warning">
                <span>There are no modifier categories to display.</span>
              </div>
            </div>
          </div>
          <div
            v-if="isModifierCategorySelected"
            class="col-md-6"
          >
            <h4>{{ activeModifier.name }} - Items</h4>
            <div v-if="loadingModifierItems && activeModifier.items === null">
              <div class="alert alert-info">
                <span>Loading...</span>
              </div>
            </div>
            <div
              v-else-if="activeModifier.items !== null && activeModifier.items.length"
              id="nestable_list_3"
              class="dd"
            >
              <ol class="dd-list">
                <li
                  v-for="item in activeModifier.items"
                  :key="item.id"
                  class="dd-item"
                  :data-id="item.id"
                >
                  <div class="dd-handle">
                    <span class="pull-left">
                      <input
                        :id="'item_checkbox_' + item.id"
                        v-model="item.selected"
                        type="checkbox"
                        class="md-check"
                        @change="itemsSelected(item)"
                      >&emsp;
                    </span>
                    <label :for="'item_checkbox_' + item.id">
                      {{ item.name }}
                      <span
                        v-if="showSku"
                        class="grey"
                      >
                        {{ item.sku }}
                      </span>
                    </label>
                  </div>
                </li>
              </ol>
            </div>
            <div v-else>
              <div class="alert alert-warning">
                <span>There are no items in the category '{{ activeModifier.name }}'.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModifiersFunctions from '../../controllers/Modifiers'
import ajaxErrorHandler from '@/controllers/ErrorController'

export default {
  props: {
    /**
     * @property {array} previouslySelected - An array of SKU strings of previously selected items
     */
    previouslySelected: {
      type: Array,
      default: () => [],
      required: false
    },
    /**
     * @property {boolean} showSku - Displays item's SKU below the item
     */
    showSku: {
      type: Boolean,
      default: () => false,
      required: false
    },
    /**
     * @property {boolean} useIds - emit IDs intead of SKUs
     */
    useIds: {
      type: Boolean,
      default: () => false,
      required: false
    }
  },
  data () {
    return {
      errorMessage: '',
      showModifierTreeModal: false,
      previous: [],
      loadingModifiers: false,
      modifiers: [],
      loadingModifierItems: false,
      items: [],
      isModifierCategorySelected: false,
      activeModifier: {
        items: []
      }
    }
  },
  computed: {
    selectedItems () {
      let allItems = []
      this.modifiers.forEach(modifier => {
        if (modifier.items !== null) {
          allItems = allItems.concat(modifier.items)
        }
      })
      return allItems.filter(item => item.selected)
    }
  },
  watch: {
    '$root.activeLocation': function () {
      this.getModifiers()
    }
  },
  created () {
    this.previous = [...this.previouslySelected]
    this.getModifiers()
  },
  mounted () {
    this.showModifierTreeModal = true
  },
  methods: {
    /**
     * To clear an error.
     * @function
     * @param {string} name - Name of the error variable to clear
     * @returns {undefined}
     */
    clearError (name) {
      this[name] = ''
    },
    /**
     * To close the modal.
     * @function
     * @param {object} item - The item toggled by the user
     * @returns {undefined}
     */
    itemsSelected (item) {
      if (!item.selected) {
        let previousIndex
        if (this.useIds) {
          previousIndex = this.previous.indexOf(item.id)
        } else {
          previousIndex = this.previous.indexOf(item.sku)
        }
        if (previousIndex !== -1) {
          this.previous.splice(previousIndex, 1)
        }
      }
      let selected = []
      if (this.useIds) {
        selected = [
          ...this.previous.map(id => ({ previous: true, id, name: '' })),
          ...this.selectedItems.filter(item => !this.previous.includes(item.id))
        ]
      } else {
        selected = [
          ...this.previous.map(sku => ({ previous: true, sku, name: '' })),
          ...this.selectedItems.filter(item => !this.previous.includes(item.sku))
        ]
      }
      this.$emit('update', selected)
    },
    /**
     * To get a list of all modifiers for the current active location.
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getModifiers () {
      if (this.$root.activeLocation.id === undefined) {
        this.errorMessage = 'Please select a store to view Modifiers.'
        return
      }
      this.clearError('errorMessage')
      this.loadingModifiers = true
      this.modifiers = []
      var modifierTreeVue = this
      return ModifiersFunctions.getStoreModifiers(
        modifierTreeVue.$root.activeLocation.id
      )
        .then(response => {
          if (response.code === 200 && response.status === 'ok') {
            modifierTreeVue.modifiers = response.payload.map(modifier => ({
              ...modifier,
              items: null,
              selected: false,
              partiallySelected: false
            }))
          }
        })
        .catch(reason => {
          ajaxErrorHandler({
            reason,
            errorText: 'We could not fetch modifiers',
            errorName: 'errorMessage',
            vue: modifierTreeVue,
            containerRef: 'modal'
          })
        })
        .finally(() => {
          modifierTreeVue.loadingModifiers = false
        })
    },
    /**
     * To get a list of all item for the current active modifier category.
     * @function
     * @param {object} modifier - The selected modifier.
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getItemsForActiveModifier (modifier) {
      this.loadingModifierItems = true
      var modifierTreeVue = this
      modifierTreeVue.items = []
      return ModifiersFunctions.getModifierCategoryItems(modifier.id)
        .then(response => {
          modifier.items = response.payload.map(item => {
            let selected
            if (modifierTreeVue.useIds) {
              selected = modifierTreeVue.previous.includes(item.id)
            } else {
              selected = modifierTreeVue.previous.includes(item.sku)
            }
            return {
              ...item,
              selected
            }
          })
        })
        .catch(reason => {
          ajaxErrorHandler({
            reason,
            errorText: 'We could not fetch items',
            errorName: 'errorMessage',
            vue: modifierTreeVue,
            containerRef: 'modal'
          })
        })
        .finally(() => {
          modifierTreeVue.loadingModifierItems = false
        })
    },
    /**
     * To clear the items array.
     * @function
     * @returns {undefined}
     */
    clearItems () {
      this.items = []
    },
    /**
     * To set the value of the variable 'activeModifier' as the selected modifier object.
     * @function
     * @param {object} modifier - The selected modifier.
     * @returns {undefined}
     */
    selectModifier (modifier) {
      this.activeModifier = modifier
      this.isModifierCategorySelected = true
      if (this.activeModifier.items === null) {
        this.getItemsForActiveModifier(modifier)
      }
    }
  }
}
</script>
<style scoped>
.height-mod {
  max-height: 400px;
  overflow: auto;
}
.dd-handle {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: nowrap;
}
.active {
  color: #2ea8e5;
  background: #fff;
}
.grey {
  color: #5f5f5f;
}
</style>
